"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartialAuthProviderConfig = exports.AuthProviderConfig = exports.MetadataField = exports.AuthProviderType = void 0;
var json2typescript_1 = require("json2typescript");
var AuthProviderType;
(function (AuthProviderType) {
    AuthProviderType["Userpass"] = "local-userpass";
    AuthProviderType["Anonymous"] = "anon-user";
    AuthProviderType["MongoDBCloud"] = "mongodb-cloud";
    AuthProviderType["APIKey"] = "api-key";
    AuthProviderType["Google"] = "oauth2-google";
    AuthProviderType["Facebook"] = "oauth2-facebook";
    AuthProviderType["Custom"] = "custom-token";
    AuthProviderType["CustomFunction"] = "custom-function";
    AuthProviderType["Apple"] = "oauth2-apple";
})(AuthProviderType = exports.AuthProviderType || (exports.AuthProviderType = {}));
var MetadataField = (function () {
    function MetadataField(partial) {
        this.required = false;
        this.name = '';
        this.fieldName = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('required'),
        __metadata("design:type", Object)
    ], MetadataField.prototype, "required", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], MetadataField.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('field_name', String, true),
        __metadata("design:type", String)
    ], MetadataField.prototype, "fieldName", void 0);
    MetadataField = __decorate([
        (0, json2typescript_1.JsonObject)('MetadataField'),
        __metadata("design:paramtypes", [Object])
    ], MetadataField);
    return MetadataField;
}());
exports.MetadataField = MetadataField;
var AuthProviderConfig = (function () {
    function AuthProviderConfig(partial) {
        this.id = undefined;
        this.name = AuthProviderType.Userpass;
        this.type = AuthProviderType.Userpass;
        this.metadataFields = undefined;
        this.domainRestrictions = undefined;
        this.redirectUris = undefined;
        this.config = undefined;
        this.secretConfig = undefined;
        this.disabled = false;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id', String, true),
        __metadata("design:type", String)
    ], AuthProviderConfig.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", String)
    ], AuthProviderConfig.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('type'),
        __metadata("design:type", String)
    ], AuthProviderConfig.prototype, "type", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('metadata_fields', [MetadataField], true),
        __metadata("design:type", Array)
    ], AuthProviderConfig.prototype, "metadataFields", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('domain_restrictions', [String], true),
        __metadata("design:type", Array)
    ], AuthProviderConfig.prototype, "domainRestrictions", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('redirect_uris', [String], true),
        __metadata("design:type", Array)
    ], AuthProviderConfig.prototype, "redirectUris", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('config', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], AuthProviderConfig.prototype, "config", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('secret_config', json2typescript_1.Any, true),
        __metadata("design:type", Object)
    ], AuthProviderConfig.prototype, "secretConfig", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('disabled'),
        __metadata("design:type", Object)
    ], AuthProviderConfig.prototype, "disabled", void 0);
    AuthProviderConfig = __decorate([
        (0, json2typescript_1.JsonObject)('AuthProviderConfig'),
        __metadata("design:paramtypes", [Object])
    ], AuthProviderConfig);
    return AuthProviderConfig;
}());
exports.AuthProviderConfig = AuthProviderConfig;
var PartialAuthProviderConfig = (function () {
    function PartialAuthProviderConfig(partial) {
        this.id = '';
        this.name = AuthProviderType.Userpass;
        this.type = AuthProviderType.Userpass;
        this.disabled = false;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id'),
        __metadata("design:type", Object)
    ], PartialAuthProviderConfig.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", String)
    ], PartialAuthProviderConfig.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('type'),
        __metadata("design:type", String)
    ], PartialAuthProviderConfig.prototype, "type", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('disabled'),
        __metadata("design:type", Object)
    ], PartialAuthProviderConfig.prototype, "disabled", void 0);
    PartialAuthProviderConfig = __decorate([
        (0, json2typescript_1.JsonObject)('PartialAuthProviderConfig'),
        __metadata("design:paramtypes", [Object])
    ], PartialAuthProviderConfig);
    return PartialAuthProviderConfig;
}());
exports.PartialAuthProviderConfig = PartialAuthProviderConfig;
//# sourceMappingURL=AuthProvider.js.map